import { atom } from 'recoil';

const showTableState = atom({
  key: 'showTableState',
  default: false,
});

export { showTableState };